import { SET_BACK_FORWARD_DIRECTORY } from '../../constants/backForward';

const backForwardDirectory = (data) => {
    return {
        type: SET_BACK_FORWARD_DIRECTORY,
        payload: data
    }
}

export { backForwardDirectory };